/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './facade-factory.service';
export { facadeFactory } from './facade-factory';
export { FacadeDescriptor } from './facade-descriptor';
